import FormattedMessage from 'I18n/components/FormattedMessage';
import { TEST_V2 } from 'automation-ui-canvas/constants/Gates';
import TestFlowSidePanel from 'automation-ui-canvas/containers/flow-views/test-flow/TestFlowSidePanel';
import { TEST_FLOW_VIEW } from 'automation-ui-canvas/containers/flow-views/flowViewIds';
import useGetTestFlowData from 'automation-ui-canvas/containers/flow-views/test-flow/useGetTestFlowData';
import TestFlowContent from 'automation-ui-canvas/containers/flow-views/test-flow/TestFlowContent';
import { jsx as _jsx } from "react/jsx-runtime";
const TestFlowViewConfig = {
  id: TEST_FLOW_VIEW,
  getIsAvailable: ({
    getIsUngated
  }) => {
    return getIsUngated(TEST_V2);
  },
  useGetViewData: useGetTestFlowData,
  modeIndicator: {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.testV2.mode"
    })
  },
  sidePanel: {
    SidePanelComponent: TestFlowSidePanel,
    width: 400
  },
  menuBar: {
    MenuBarComponent: null
  },
  ContentComponent: TestFlowContent
};
export default TestFlowViewConfig;